export class PlantOptionsLoad {
  public static readonly type = '[PlantOptions]  Load';
  constructor(public payload: string) {}
}

export class PlantOptionsInitialState {
  public static readonly type = '[PlantOptions] Set Initial State';
}
